import { smallStudiesIcon, editIcon } from '@/shared/ui/assets';
import { useEffect, useState } from 'react';
import { t } from 'ttag';
import { generateEditReportLink } from '../../../../../lib/headerRightButtons';
import type { HeaderRightButtonsProps } from './layout.types';

/**
 * Builds the edit-report and manage-study icon links in an event list item header.
 * Rebuilds the list whenever the event or its conflict users change, warning on the edit-report
 * link and flagging it as a conflict while someone else is editing the report.
 *
 * @param props - Header props carrying the event data and its conflictUsers.
 * @returns An object carrying the icon link button list.
 */
export const useHeaderRightButtons = ({
  data,
  conflictUsers,
}: Pick<HeaderRightButtonsProps, 'data' | 'conflictUsers'>) => {
  const [listButton, setListButton] = useState<any[]>([]);

  useEffect(() => {
    const icons = [
      {
        id: `edit-report-${data.id}`,
        name: conflictUsers?.length
          ? t`Someone is editing this report. You should not make changes to this report at this time`
          : t`Edit report`,
        image: editIcon,
        imageAlternate: t`Edit report icon`,
        isIconLinkButton: true,
        link: generateEditReportLink(data),
        isConflictButton: !!conflictUsers?.length,
      },
      {
        id: `manage-study-${data.id}`,
        name: t`Manage study`,
        image: smallStudiesIcon,
        imageAlternate: t`Manage study icon`,
        isIconLinkButton: true,
        link: `/studies/${data.studyId}`,
      },
    ];

    setListButton(icons);
  }, [data, conflictUsers]);

  return { listButton };
};
